<template>
	<div class="main" v-title data-title="零部件网站会员开通协议">
		<iHeader></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<div class="barprebox bgwhite">
				<div class="mt25 ml20 txl">
					<div class="mt10 txc" style="border-bottom: 1px solid #ccc;">
						<h1 class="color1 font18 item1 txc">会员开通协议</h1>
						<p class="txc pd20 font12">发布日期:2021.1.1</p>
					</div>
				</div>
				<div class="formWBase txl">
					<div class="list-item">
						<div class="noticeD ">
							<p>
								在购买“沐风零部件会员”前，您应当阅读并遵守《沐风零部件会员协议》（以下简称“本协议”）以及其他沐风零部件库发布的服务协议、交易规则。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。除非您已阅读并接受本协议所有条款，否则您无权使用“沐风零部件会员”服务（以下简称“本服务”）。您对本服务的登录、查看、使用服务等行为即视为您已阅读并同意本协议的约束。如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。
							</p>
							<p class="fw">
								一、定义
							</p>
							<p>
								本协议是您与沐风零部件库之间关于您使用本服务所订立的协议。“您”是指已经在沐风零部件库站开通账号的用户（本协议中简称“用户”），“沐风零部件库”是指沐风网及其相关服务可能存在的运营关联单位（本协议中简称“本平台”）。
							</p>
							<p class="fw">
								二、服务须知
							</p>
							<p>
								2.1沐风零部件会员包含企业会员 0元/年，超级会员 2980元/年。本服务的期限以您自行选择并支付相应服务费用的期限为准。
							</p>
							<p>2.2本平台收到用户全款后，在七个工作日之内为用户开通所购买的产品的所有服务（部分暂未上线产品除外）。</p>
							<P>2.3服务费用一经缴纳，除本协议另有约定外概不退还。</P>
							<p>
								2.4本平台为推广服务而通过网页、宣传单等进行的宣传仅为用户了解服务产品使用，具体权利义务内容以双方签署确认的书面协议为准（包含签署在线协议）。
							</p>
							<p>
								2.5会员费发票申请方式：购买会员后可联系平台客服进行索取，注明平台实名认证名称及开具增值税普通发票还是增值税专用发票。
							</p>
							<p class="fw">
								三、双方权利和义务
							</p>
							<p>
								3.1用户权利义务
							</p>
							<p>3.1.1用户需遵守国家法律法规和本平台的交易规则（包含本平台网站（https://www.mfcad.cn/）的服务协议和交易规则等所有网站规定）, 履行协议承诺，接受本平台的规则变动。</p>
							<p>3.1.2用户有权向本平台提出相关意见和建议，但不得对本平台进行负面评价等有损本平台品牌形象的行为。</p>
							<p>3.1.3用户需承诺绝不进行虚假交易和出售违法违规的服务。用户不得通过虚构或隐瞒交易事实、利用或规避信用记录规则、干扰或妨害信用记录秩序等不正当方式获取虚假的评分等不当利益，破坏正常交易秩序。</p>
							<p>3.2本平台权利义务</p>
							<p>3.2.1本平台须按照本协议约定按时为接包法开通所有产品服务。</p>
							<p>3.2.2本平台有权监督甲方的交易行为，并按照网站规定介入交易。</p>
							<p class="fw">四、特别条款</p>
							<p>4.1用户如果存在伪造证件等情形，本平台有权单方终止服务，用户所交付的费用不予退还。</p>
							<p>4.2如因为用户自身原因违反本平台其他相关规则造成不良影响导致本平台对用户账号进行封号或其他终止提供服务行为，用户所交付的费用不予退还。</p>
							<p>4.3用户违反本规则约定，对本平台进行不实的负面评价，造成本平台品牌或名誉受损，本平台有权单方终止协议，所收取的费用不予退还；同时本平台保留进一步追究用户法律责任的权利。</p>
							<p>4.4用户不得以自身原因如解散、转型、产品升级等非正当理由要求本平台退还费用。</p>
							<P>4.5如平台自身产品调整导致本服务部分权益或者全部权益取消，双方确认按照用户实际使用本服务时长在整个服务期的比例，按天折算并计算费用后退还剩余费用。</P>
							<p>4.6用户以明示或者默示的方式放弃部分权益内容的（特指需要用户通过申请、报名及其他主动积极的行动方可享受的权益），应视为对其自身权益的处置，此种情形本平台不承担任何责任。</p>
							<p>4.7用户开通会员后，仅可在会员有效期内享受服务费减免等优惠。超出有效期则无优惠。</p>
							<P>4.8用户重复购买同等级会员，则视为会员续费，自动增加相应的会员有效期。用户购买更高等级会员，则视为会员升级，购买高等级会员后，会优先享受高等级会员相关权益，在高等级会员到期后，可继续享受原等级会员的相关权益及剩余的有效期。</P>
							<p class="fw">五、不可抗力</p>
							<p>若因不可抗力使得本协议履行不可能、不必要或者无意义的，遭受不可抗力的一方不承担责任，不可抗力是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为。</p>
							
							<p></p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	export default {
		components: {
			iHeader,
			vFooter,
			vnav,
		},
		data() {
			return {
				noticeinfo: [],
				goods_id: ''
			};
		},
		created() {},
		methods: {

		}
	}
</script>

<style scoped>
	.list-item .noticeD {
		position: relative;
		padding: 10px 20px;
		font-size: 14px;
	}

	.list-item .noticeD p {
		font-size: 16px;
		color: #717171;
		font-weight: 400;
		line-height: 26px !important;
		margin: 0 0 16px;
		overflow-x: auto;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.el-divider {
		margin: 12px 0px;
	}

	.fw {
		font-weight: bold !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/notice/vipagreement.vue